import { render, staticRenderFns } from "./folderTree.vue?vue&type=template&id=5b052383&scoped=true"
import script from "./folderTree.vue?vue&type=script&lang=js"
export * from "./folderTree.vue?vue&type=script&lang=js"
import style0 from "./folderTree.vue?vue&type=style&index=0&id=5b052383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b052383",
  null
  
)

export default component.exports